<template>
  <div class="generateIndex-main">
    <div class="generateIndex-left">
      <el-menu
        default-active="generate-page"
        class="el-menu-vertical-demo"
        :default-openeds="defaultOpenedArr"
        active-text-color="#409EFF"
        @select="handleSelect"
        @open="handleOpen"
        @close="handleClose">
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-s-grid"></i>
            <span>应用</span>
          </template>
          <el-menu-item index="api-form">
            <template slot="title">
              <i class="el-icon-s-management"></i>
              <span>表单</span>
            </template>
          </el-menu-item>
          <el-menu-item index="api-table">
            <template slot="title">
              <i class="el-icon-s-management"></i>
              <span>页面配置</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="generateIndex-right">
      <router-view v-slot="{ Component }" :key="$route.name">
        <transition name="move" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApiIndex",
  data(){
    return {
      defaultOpenedArr:['1','2']
    }
  },
  methods: {
    handleSelect(path) {
      this.$router.push(path)
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
}
</script>

<style scoped>
  .generateIndex-main{overflow: hidden;height: 100%;}
  .generateIndex-left{float: left;width: 220px;height: 100%;}
  .generateIndex-right{float: left;width: calc(100% - 220px);height: 100%;}
  .el-menu{height: 100%;}
</style>



// WEBPACK FOOTER //
// src/views/api/Index.vue